import api from 'api'
import { Dispatch, SetStateAction } from 'react'
import { Campaign } from 'types/campaign'

export default class CampaignFormService {
  static getCampaignImpressionsBasedOnAudience = ({
    campaignId,
    setEstimatedImpressions,
    setHiddenTarget,
    setLoading,
  }: {
    campaignId: Campaign['id']
    setEstimatedImpressions: Dispatch<SetStateAction<number | null>>
    setHiddenTarget: Dispatch<SetStateAction<number | null>>
    setLoading: Dispatch<SetStateAction<boolean>>
  }): void => {
    setLoading(true)

    api.campaign
      .getCampaignImpressionsBasedOnAudience(campaignId)
      .then(res => {
        setEstimatedImpressions(res.data.campaignImpressionsBasedOnAudience.impressions)
        setHiddenTarget(res.data.campaignImpressionsBasedOnAudience.hiddenTarget)
      })
      .catch(() => void {})
      .finally(() => void setLoading(false))
  }
}
